import { NavItem, navigationItems } from '@config/nav'
import { useCallback, useMemo } from 'react'

import { hasPermissions } from '@services/auth/auth.service'
import { useAppSelector } from '@hooks/store'
import { useScreenSize } from '@hooks/utils'
import HeaderTabletNav from './HeaderTabletNav'
import HeaderDesktopNav from './HeaderDesktopNav'
import HeaderMobileNav from './HeaderMobileNav'

const HeaderNavMenu = () => {
    const { isDesktop, isTablet, isMobile } = useScreenSize()
    const { user } = useAppSelector((state) => state.auth)

    const getNavItemsForUser = useCallback(
        (items: NavItem[]) =>
            items.reduce((acc: NavItem[], curr) => {
                const hasPermission =
                    !curr.permissions ||
                    curr.permissions.length === 0 ||
                    hasPermissions(curr.permissions)

                if (hasPermission) return [...acc, curr]

                if (curr.alt) {
                    const hasAltPermission =
                        !curr.alt.permissions ||
                        curr.alt.permissions.length === 0 ||
                        hasPermissions(curr.alt.permissions)

                    if (hasAltPermission)
                        return [
                            ...acc,
                            {
                                ...curr,
                                href: curr.alt.href || curr.href,
                                name: curr.alt.name || curr.name,
                            },
                        ]
                }

                return acc
            }, []),
        [user]
    )

    const navItems = useMemo(() => {
        let userItems: NavItem[] = []
        getNavItemsForUser(navigationItems).forEach((i) => {
            if (i.items && i.items.length > 0) {
                const subItems = getNavItemsForUser(i.items)
                if (subItems && subItems.length > 0)
                    userItems = [...userItems, { ...i, items: subItems }]
            } else {
                userItems = [...userItems, { ...i }]
            }
        })
        return userItems
    }, [user, navigationItems])

    return (
        <>
            {isMobile && <HeaderMobileNav items={navItems} />}
            {isTablet && <HeaderTabletNav items={navItems} />}
            {isDesktop && <HeaderDesktopNav items={navItems} />}
        </>
    )
}

export default HeaderNavMenu
